<template>
  <div class="newVoucher">
    <div class="goCar" @click="goCar"></div>
    <img src="https://cms.dafang24.com/aliapp/20191012/newMember.png">
  </div>
</template>

<script>
import { imgUrl, orderSource } from "@/utils/env";
export default {
  name: 'newVoucher',
  data(){
    return {
      imgUrl: imgUrl
    }
  },
  created () {},
  mounted () {},
  methods: {
    goCar () {
      if(orderSource==16){
        dfpanda.goHome();
      } else if(orderSource==17){
        window.webkit.messageHandlers.goHome.postMessage(null);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
html, body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #3B64B4;
}
.newVoucher {
  width: 100%;
  position: relative;
  img { width: 100%; }
  .goCar {
    width: 70%;
    height: 300px;
    position: absolute;
    top: 25%;
    left: 15%;
    /*background-color: rgba(0, 0, 0, .5);*/
  }
}
</style>